import React__default, { useRef, useEffect } from 'react';

const SearchSuggestion = ({ suggestion , targetPath , onClick  })=>{
    const linkRef = useRef(null);
    useEffect(()=>{
        if (linkRef.current) {
            linkRef.current.focus();
        }
    }, []);
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "search-suggestion__item"
    }, /*#__PURE__*/ React__default.createElement("a", {
        ref: linkRef,
        className: "search-suggestion__link",
        href: `${targetPath}${suggestion.query}`,
        onClick: ()=>{
            return onClick === null || onClick === void 0 ? void 0 : onClick(suggestion.objectID, suggestion.position);
        }
    }, suggestion.query));
};
var SearchSuggestion$1 = SearchSuggestion;

export { SearchSuggestion$1 as default };
//# sourceMappingURL=SearchSuggestion.js.map
